import { Col, TabContent, TabPane } from "reactstrap";
import { useAppSelector } from "../../../../../reduxToolkit/hooks";
import BasicDetails from "./BasicDetails";
import Gallery from "./Gallery";
import Categories from "./categories";
import Pricing from "./Pricing";
import AdvancedSettings from "./advancedSettings";
import CommonButton from "./Button";

// This component handles the tabbed navigation for adding a product.
const ProductTabs = () => {
  const { navId } = useAppSelector((state) => state.addProduct);
  return (
    <>
      <Col xxl="9" xl="8" className="box-col-8 position-relative">
        <TabContent activeTab={navId}>
          <TabPane tabId={1}>
            <BasicDetails />
          </TabPane>
          <TabPane tabId={2}>
            <Gallery />
          </TabPane>
          <TabPane tabId={3}>
            <Categories />
          </TabPane>
          <TabPane tabId={4}>
            <Pricing />
          </TabPane>
          <TabPane tabId={5}>
            <AdvancedSettings />
          </TabPane>
        </TabContent>
      </Col>
      <CommonButton />
    </>
  );
};

export default ProductTabs;